module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0023.1bd4077c.jpg";